import React from 'react';
import PropTypes from 'prop-types';
import PaginatedTable from '@/components/molecules/PaginatedTable/PaginatedTable';
import styles from './Leaderboard.module.scss';

const LEADERBOARD_ROWS_PER_PAGE_OPTIONS = [5, 10, 15, 20, 25];

const LeaderboardTable = ({data, period}) => {
  const columns = [
    {key: 'rank', label: 'RANK'},
    {key: 'points', label: 'POINTS'}
  ];

  return (
    <PaginatedTable
      columns={columns}
      data={data}
      resetPageKey={period}
      rowsPerPageOptions={LEADERBOARD_ROWS_PER_PAGE_OPTIONS}
      sortType='numeric'
      emptyMessage='No leaderboard data is available in this tab. Please upload a template if required'
      title={
        <h4 className='mb-4 mt-8 text-[16px] font-bold leading-[22px] text-[#FFFFFF]'>
          {period} Leaderboard
        </h4>
      }
      containerClassName={styles.leaderboardTableContainer}
      wrapperClassName={styles.tableWrapper}
      tableClassName={styles.leaderboardTable}
      sortableHeaderClassName={styles.sortableHeader}
      renderRow={(row) => (
        <tr key={row.rank}>
          <td>{row.rank}</td>
          <td>{row.points}</td>
        </tr>
      )}
    />
  );
};

LeaderboardTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      rank: PropTypes.number.isRequired,
      points: PropTypes.number.isRequired
    })
  ).isRequired,
  period: PropTypes.string.isRequired
};

export default React.memo(LeaderboardTable);
